var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.139 1.165h-1.94V.74a.722.722 0 00-.71-.739.722.722 0 00-.71.739v.426H5.19V.74A.722.722 0 004.48 0a.722.722 0 00-.71.739v.426H1.846C.836 1.165 0 2.02 0 3.085v9.995C0 14.13.82 15 1.845 15h11.31C14.164 15 15 14.147 15 13.08V3.085c-.016-1.066-.836-1.92-1.861-1.92zM1.848 2.643h1.94v.426c0 .41.315.739.71.739.394 0 .71-.328.71-.739v-.426h4.59v.426c0 .41.315.739.709.739.394 0 .71-.328.71-.739v-.426h1.94c.236 0 .426.197.426.443v1.953H1.422V3.086c0-.246.19-.443.426-.443zm0 10.88H13.14c.237 0 .426-.198.442-.444V6.498H1.422v6.581c0 .246.19.443.426.443z",
    fill: "#6373A4"
  })));
}

export default SvgCalendar;